
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const DataProtection = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-700 mb-8 transition-colors"
        >
          <ArrowLeft size={16} />
          Back to Home
        </Link>
        
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Data Protection & Security</h1>
        
        <div className="bg-white rounded-lg shadow-sm p-8">
          <p className="text-gray-600 leading-relaxed">
            This page will detail ZimKonnect's comprehensive approach to data protection 
            and security. We implement industry-standard security measures to protect 
            your information and ensure secure transactions when working with suppliers 
            and tracking projects in Zimbabwe.
          </p>
        </div>
      </div>
    </div>
  );
};

export default DataProtection;
